(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["timeline"] && !Shopify.designMode) return;
  try {
    
 const timelineToggle = document.getElementById("timeline-toggle");
      timelineToggle.onclick = function () {
        let timeline = document.getElementById("mobile-timeline");
        timeline.style.height = `${timeline.scrollHeight}px`;
        timelineToggle.style.display = "none";
      };
 window.addEventListener("scroll", function () {
        let windowScroll = window.pageYOffset;
        let horizontalWrapper = document.getElementById(
          "horizontal-scroll__wrapper"
        );
        let horizontalScroll = document.getElementById("horizontal-scroll");
        let header = document.querySelector("#horizontal-scroll .timeline-header");

        horizontalWrapper.classList.remove("sticky");
        horizontalWrapper.classList.remove("post-sticky");

        horizontalWrapper.style.height = `${horizontalScroll.scrollWidth}px`;
       // horizontalWrapper.style.width = `${horizontalScroll.scrollWidth}px`;
        console.log(`
        windowScroll: ${windowScroll}
        offsetTop: ${horizontalWrapper.offsetTop}
        offsetHeight: ${horizontalWrapper.offsetHeight}
        offsetWidth: ${horizontalWrapper.offsetWidth}
        window.innerHeight: ${window.innerHeight}
        window.innerWidth: ${window.innerWidth}
        `);

        switch (true) {
          case windowScroll >=
            horizontalWrapper.offsetTop +
              horizontalWrapper.offsetHeight -
              window.innerHeight:
            horizontalWrapper.classList.add("post-sticky");
            break;
          case windowScroll >= horizontalWrapper.offsetTop:
            horizontalWrapper.classList.add("sticky");

            let start = windowScroll - horizontalWrapper.offsetTop;
            let end =
              horizontalWrapper.offsetTop +
              horizontalWrapper.offsetHeight -
              window.innerHeight +
              1200;
            let pct = (start / end) * 100;

            horizontalScroll.style.transform = `translate(-${pct}%)`;
            header.style.transform = `translate(${pct}%)`;
            break;
          default:
            horizontalScroll.style.transform = `translate(0%)`;
            break;
        }
      });

  } catch(e) { console.error(e); }
})();
})();
